import React from "react";
import star from "../../assets/images/devdetail/star.svg";
import location from "../../assets/images/devreview/locationdev.svg";
import phone from "../../assets/images/devreview/phonedev.svg";
import verified from "../../assets/images/devreview/verifieddev.svg";

const ReviewDetail = () => {
  return (
    <div className='review-detail-content'>
      <div className='review-detail-content-mobile'>
        <div className=' dev-detail-reviews'>
          <ul>
            <li>
              <img src={star} alt='' className='dev-detail-content-top-img' />
              5.0
            </li>
            <li>7 reviews</li>
          </ul>
        </div>
        <div className='review-sidebar-detail'>
          <div className='review-detail'>
            <img src={location} alt='location' />
            <p>Denmark</p>
          </div>
          <div className='review-detail'>
            <img src={phone} alt='location' />
            <p>Phone Interview</p>
          </div>
          <div className='review-detail'>
            <img src={verified} alt='location' />
            <p>Verified</p>
          </div>
        </div>
      </div>
      <div className='review-heading'>
        <h4>Luke</h4>
      </div>
      <div className='dev-detail-history-rating'>
        <div className='dev-history-rating'>
          <img src={star} alt='star' />
          <span>5.0</span>
        </div>
        <p>Jan 10, 2022 - Feb 23, 2022</p>
      </div>
      <div className='review-heading' id='item1'>
        <h4>Project summary:</h4>
      </div>
      <div className='review-paragrapgh'>
        <p>
          Artem is a hard-working perfectionist who is always ready to put all
          his energy into the current project in the fast-paced product cycle.
          He is a world-class and highly motivated software engineer with strong
          technical skills. It was really productive and inspiring to work with
          him. I definitely would want to work with him again later.
        </p>
      </div>
      <div className='review-heading' id='item2'>
        <h4>Feedback summary:</h4>
      </div>
      <div className='review-paragrapgh'>
        <p>
          Artem is a hard-working perfectionist who is always ready to put all
          his energy into the current project in the fast-paced product cycle.
          He is a world-class and highly motivated software engineer with strong
          technical skills. It was really productive and inspiring to work with
          him. I definitely would want to work with him again later.
        </p>
      </div>
      <div className='review-heading' id='item3'>
        <h4>Opportunity / Challenge:</h4>
      </div>
      <div className='review-paragrapgh'>
        <p>
          Artem is a hard-working perfectionist who is always ready to put all
          his energy into the current project in the fast-paced product cycle.
          He is a world-class and highly motivated software engineer with strong
          technical skills. It was really productive and inspiring to work with
          him. I definitely would want to work with him again later.
        </p>
      </div>
      <div className='review-heading' id='item4'>
        <h4>Solution:</h4>
      </div>
      <div className='review-paragrapgh'>
        <p>
          The product that Imaginary Cloud is developing for us works reliably,
          and the code is solid. We rarely find any bugs after a feature has
          gone live, and when we do, it's usually minor. Additionally, the
          amount of customer support we receive continues to decrease. The work
          Imaginary is doing is simply amazing.
        </p>
      </div>
      <div className='review-heading'>
        <h4>Lorem :</h4>
      </div>
      <div className='review-paragrapgh'>
        <p>
          Artem is a hard-working perfectionist who is always ready to put all
          his energy into the current project in the fast-paced product cycle.
          He is a world-class and highly motivated software engineer with strong
          technical skills. It was really productive and inspiring to work with
          him. I definitely would want to work with him again later.
        </p>
      </div>
      <div className='review-heading'>
        <h4>Lorem :</h4>
      </div>
      <div className='review-paragrapgh'>
        <p>
          The product that Imaginary Cloud is developing for us works reliably,
          and the code is solid. We rarely find any bugs after a feature has
          gone live, and when we do, it's usually minor. Additionally, the
          amount of customer support we receive continues to decrease. The work
          Imaginary is doing is simply amazing.
        </p>
      </div>
      <div className='review-heading'>
        <h4>Lorem :</h4>
      </div>
      <div className='review-paragrapgh'>
        <p>
          Artem is a hard-working perfectionist who is always ready to put all
          his energy into the current project in the fast-paced product cycle.
          He is a world-class and highly motivated software engineer with strong
          technical skills. It was really productive and inspiring to work with
          him. I definitely would want to work with him again later.
        </p>
      </div>
      <div className='review-heading'>
        <h4>Lorem :</h4>
      </div>
      <div className='review-paragrapgh'>
        <p>
          The product that Imaginary Cloud is developing for us works reliably,
          and the code is solid. We rarely find any bugs after a feature has
          gone live, and when we do, it's usually minor. Additionally, the
          amount of customer support we receive continues to decrease. The work
          Imaginary is doing is simply amazing.
        </p>
      </div>
    </div>
  );
};

export default ReviewDetail;
